<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `master/course-type/${inputs.id}`
						: `master/course-type`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_course_type_id" class="col-sm-3 mb-0">
						ID
					</label>
					<app-input
						id="inputs_course_type_id"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_type_id"
						:placeholder="ID"
						:required="true"
					/>
				</div>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_name" class="col-sm-3 mb-0">
						{{ $t("name") }}
					</label>
					<app-input
						id="inputs_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_type_name"
						:placeholder="$t('name')"
						:required="true"
					/>
				</div> -->

                <div class="form-group row align-items-center">
					<label
						for="inputs_course_type_code"
						class="col-sm-3 mb-0"
					>
						Code
					</label>
					<app-input
						id="inputs_course_type_code"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_type_code"
						:placeholder="'Code'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_course_type_desc"
						class="col-sm-3 mb-0"
					>
						Desc
					</label>
					<app-input
						id="inputs_course_type_desc"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_type_desc"
						:placeholder="'Desc'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					// course_type_name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				course_type_name: "",
			},
			// statusLists: [
			//     {id: '', value: "Choose One",},
			//     {id: 'active', value: "Active",},
			//     {id: 'inactive', value: "Inactive",},
			//     {id: 'invited', value: "Invite",},
			// ],
			// genderLists: [
			//     {id: 'male', value: "Male"},
			//     {id: 'female', value: "Female"},
			//     {id: 'other', value: "Other"},
			// ],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
